// src/home/Home.js
import React, { useState } from 'react';
import './Home.css';
import Sidebar from '../../components/sidebar/Sidebar';
import Sectiondetails from '../../components/sectiondetails/Sectiondetails';

const Main = () => {
  // Активный раздел по умолчанию установлен в "Доходы"
  const [activeSection, setActiveSection] = useState('income');

  // Функция переключения разделов: при клике на новый раздел он устанавливается как активный,
  // а повторный клик не сбрасывает активное состояние.
  const handleToggleSection = (section) => {
    if (section !== activeSection) {
      setActiveSection(section);
    }
  };

  return (
    <div className="mainContainer">
      <div className="sidebarContainer">
        <Sidebar activeSection={activeSection} handleToggleSection={handleToggleSection} />
      </div>
      <div className="contentContainer">
        <Sectiondetails activeSection={activeSection} />
      </div>
    </div>
  );
};

export default Main;
